fragment RoleFragment on Role {
    id
    name
    position
    isImmutable
    permissions
    usersCount
    isDefault
}
